import { render, staticRenderFns } from "./EmployerDialog.vue?vue&type=template&id=037b31c1&"
import script from "./EmployerDialog.vue?vue&type=script&lang=js&"
export * from "./EmployerDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports